import VerticalBarChart from './verticalBarChart.component';

export default VerticalBarChart;